import React from 'react'
import { useTranslation } from 'react-i18next';
import BarChartProjectReport from '../../../../../Projects/ProjectsReport/components/BarChartProjectReport/BarChartProjectReport';

const LastFiveYears = ({ chartData }) => {
    const { t } = useTranslation();

    return (
        <>
            <h3 className="cell-title">
                {t('extended_report.disbursements_and_projections')}
            </h3>
            <div className='grid-disbursements'>
                <div className='disbursment-for-year'>
                    <p>{t('extended_report.disbursements_for_year')}</p>
                </div>
                <div className='size-height-bar '>
                    <div className='inidicators-bar-chart'>
                        <div className='projection-and-amount-indicator'>
                            <div className='projection-icon'></div>
                            <p>{t('one_pager_report.original_projection')}</p>
                        </div>

                        <div className='projection-and-amount-indicator'>
                            <div className='amount-disbursed-icon'></div>
                            <p>{t('one_pager_report.amount_disbursed')}</p>
                        </div>
                    </div>
                    <BarChartProjectReport chart={chartData} />
                </div>
            </div>
        </>
    )
}

export default LastFiveYears